import { createContext, useContext } from 'react';
import type { Property } from './PropertySettingsLayout';

interface PropertySettingsContextValue {
    property: Property;
    refreshProperty: () => Promise<void>;
}

export const PropertySettingsContext = createContext<PropertySettingsContextValue | null>(null);

export const usePropertySettings = (): PropertySettingsContextValue => {
    const context = useContext(PropertySettingsContext);
    if (!context) {
        throw new Error('usePropertySettings must be used within PropertySettingsLayout');
    }
    return context;
};
